module.exports = __webpack_public_path__ + "img/we-bg.d7b8caf2.jpg";